import React, { lazy, Suspense, useState, useEffect } from 'react'
import { X } from 'react-feather'
import { useSelector } from 'react-redux'
import { Link, Route, Switch } from 'react-router-dom'
import { AddButton, Fallback } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { DashboardLayout } from '../../layouts'
import { dashboardRoutes as routes } from '../../routes'
// import { ListNav } from '../dashboard-programs/components'

const DashboardStatistics = lazy(() => import('../dashboard-statistics/dashboard-statistics'))
const DashboardPrograms = lazy(() => import('../dashboard-programs/listing/dashboard-programs'))

const Dashboard = (props) => {
  const { pathname } = props.location
  const title = props.location.state && props.location.state !== null ? props.location.state.title : undefined
  const createRoute = props.location.state && props.location.state !== null ? props.location.state.createRoute : undefined
  const { isVerified, isIndividu } = useSelector(state => state.account)
  const { language } = useInternationalization()

  // const [programsActiveTab, setProgramsActiveTab] = React.useState('Field Program')
  const mobileNavs = {
    // '/dashboard/programs': <ListNav activeTab={programsActiveTab} onChange={setProgramsActiveTab}/>
  }
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    setShowWarning(!isVerified)
  }, [isVerified])

  return (
    <DashboardLayout
      title={title}
      noContainer
      addButton={createRoute ? <AddButton route={createRoute}/> : false}
      mobileNav={mobileNavs[pathname]}
    >
      {
        (isIndividu && showWarning) && <>
          <div className="relative mb-8">
            <div className="absolute right-0 top-0 p-5">
              <X className="cursor-pointer" onClick={() => setShowWarning(false)}/>
            </div>
            <p className="p-5 bg-toast-warning text-center">
              {
                language.name === 'id' && <>
                  Akun Anda belum terverifikasi.<br /><Link className="underline" to="/dashboard/settings">Pelajari lebih lanjut di bagian <strong>Account Verification</strong> pada halaman ini.</Link>
                </>
              }
              {
                language.name === 'en' && <>
                Your account is not verified.<br /><Link className="underline" to="/dashboard/settings">Learn more in the Account Verification section on this page.</Link>
                </>
              }
            </p>
          </div>
        </>
      }
      <Suspense fallback={<Fallback />}>
        <Switch>
          {
            routes.map((route, index) => (
              <Route
                path={route.path} key={index}
                render={props => (
                  <route.component {...props} {...route}/>
                )}
              />
            ))
          }
          <Route path="/dashboard/programs">
            <DashboardPrograms />
          </Route>
          <Route path="/dashboard">
            <DashboardStatistics />
          </Route>
        </Switch>
      </Suspense>
    </DashboardLayout>
  )
}

export { Dashboard }
